import { Alert, Button, Spinner, Text } from "@softmax/design-system";

export function AccountStatus({
  state,
  onRetry,
}: {
  readonly state:
    | { readonly status: "loading" }
    | { readonly status: "error" | "empty"; readonly message: string };
  readonly onRetry: () => void;
}) {
  if (state.status === "loading")
    return (
      <output>
        <Spinner /> Loading account…
      </output>
    );

  if (state.status === "empty")
    return (
      <Text as="p" tone="muted">
        {state.message}
      </Text>
    );

  return (
    <Alert tone="danger" announcement="assertive">
      {state.message} <Button onClick={onRetry}>Try again</Button>
    </Alert>
  );
}
